import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLHeadElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLHeadElement
 */
export default class HTMLHeadElement extends HTMLElement {}
